import { enableProdMode, ViewEncapsulation } from '@angular/core';
import { environment } from './environments/environment';
import * as __NgCli_bootstrap_1 from "./app/app.module.ngfactory";
import * as __NgCli_bootstrap_2 from "@angular/platform-browser";
if (environment.production) {
    enableProdMode();
}
var bootstrap = function () {
    return __NgCli_bootstrap_2.platformBrowser()
        .bootstrapModuleFactory(__NgCli_bootstrap_1.AppModuleNgFactory, [
        {
            defaultEncapsulation: ViewEncapsulation.None,
            preserveWhitespaces: false,
        },
    ])
        .catch(function (err) { return console.log(err); });
};
var ɵ0 = bootstrap;
bootstrap();
export { ɵ0 };
